import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimengModule } from '@app/shared/modules/primeng.module';
import { MailTemplateComponent } from './mail-template.component';

@NgModule({
  imports: [
    CommonModule,
    PrimengModule,
    FormsModule,
    ReactiveFormsModule
    //  DirectivesModule
  ],
  declarations: [MailTemplateComponent],
  exports: [MailTemplateComponent]
})
export class MailTemplateModule {}
